import React, { useEffect, useState } from "react";
import Button from "sushiweb/Button";
import Input from "sushiweb/InputTypes/Input";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverTagsActions from "../../../store/actions/DriverTags";
import * as UserActions from "../../../store/actions/User";
import { getInitialState, isValNull } from "../../../utils";
import FileUpload from "../../Common/FileUpload";
import Errors from "../../../constants/Errors.json";
import { isValidated, getReadableDateTime, filterObj } from "../../../utils";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import variables from "../../../constants/assets/variables";
import NoFooterModal from "../../Common/NoFooterModal";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import ToggleSwitch from "../../Common/ToggleSwitch";
import {
  BottomSectionModal,
  NotesSection,
} from "../../../constants/assets/containers";
import InformationBar from "../../Common/InformationBar";

const mandatoryFields = ["name", "tag_type"];

const instructions = [
  "Allowed actions are add and delete",
  "In tag no special characters are allowed other then underscore. Space is also not allowed.",
  "There should be no space in name of the file. For example,<b>bulk_driver_tags_modifier (1).csv</b> is not allowed",
  "Please refrain from putting anything else in columns other than csv format that affect the formatting of the file and can result in failures.",
];

const sample_other_tag_csv = `${
  process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL.replace(
        variables.routeEndpoint,
        variables.sampleFileEndPoint
      )}/sample/bulk_driver_tags_modifier.csv`
    : ""
}`;

const sample_incentive_tag_csv = `${
  process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL.replace(
        variables.routeEndpoint,
        variables.sampleFileEndPoint
      )}/sample/bulk_driver_incentive_tags_uploader.csv`
    : ""
}`;

const sample_accounting_tag_csv = `${
  process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL.replace(
        variables.routeEndpoint,
        variables.sampleFileEndPoint
      )}/sample/bulk_future_driver_accounting_tags_uploader.csv`
    : ""
}`;
const [bulk_upload_url, simple_url] = ["/tag-mapping/bulk-upsert-tags", "/tag"];

const DriverTagsFormModal = (props) => {
  const {
    modalState,
    handleClose,
    activeId,
    activeDriverTag,
    activeFilters,
    filterFields,
    currentPageTags,
    updateDriverTag,
    setStatus,
    allMenuActions,
    isBulkUpload,
  } = props;
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const [activeFile, setActiveFile] = useState("");
  const [initialState, setInitialState] = useState({
    name: "",
    tag_type: "",
    enabled: false,
    updated_at: "",
    created_at: "",
  });
  const allActions = MenuActionsMappings[MenuNames.DRIVER_TAG];
  const driverTags = [
    "ACCOUNTING",
    "ACCOUNTING_STRATEGY",
    "MING_TAG",
    "OTHER",
    "INCENTIVE",
    "SUPPORT_FEE_DISCOUNT"
  ];
  const getBulkUploadUrl = () => {
    switch (initialState["tag_type"]) {
      case "OTHER":
        return bulk_upload_url + "/other";
      default:
        return bulk_upload_url + "/future-accounting";
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let body = filterObj(initialState, ["name", "tag_type", "enabled"]);

    //if filter button is clicked then apply filters
    if (modalState === "Filter") {
      let filters = {};
      for (let key of filterFields) {
        if (body[key] !== "") {
          filters[key] = body[key] + "";
        }
      }
      if (filters["tag_type"]) {
        filters["type"] = filters["tag_type"];
        delete filters["tag_type"];
      }
      props.getDriverTagsList(filters).then((res) => {
        handleClose();
      });
    } else {
      //before hitting api, check if all validations like mandatory fields are satisfied
      //consider bulk upload and change url path according to that
      let values_to_test = { ...body };
      let mandatoryFieldsToCheck = [...mandatoryFields];
      if (isBulkUpload) {
        values_to_test = {
          tag_type: body.tag_type,
          file: activeFile,
        };
        body = {
          tag_type: body.tag_type,
        };
        mandatoryFieldsToCheck = ["tag_type", "file"];
      }
      let validatedState = isValidated(values_to_test, mandatoryFieldsToCheck);
      if (validatedState === "validated") {
        let pageRequest = {
          page: currentPageTags,
        };
        if (modalState === "Add") {
          props
            .createDriverTag(
              isBulkUpload ? getBulkUploadUrl() : simple_url,
              body
            )
            .then((res) => {
              if (res) {
                setCallback_key(res.callback_key);
                setPresign_url(res.file_upload_url);
                !isBulkUpload &&
                  props.getDriverTagsList(activeFilters, pageRequest);
                !isBulkUpload && handleClose();
              } else {
                setStatus({ type: "error", message: Errors.GENERAL_ERROR });
              }
            });
        } else {
          props.updateDriverTag(activeId, body).then((res) => {
            props.getDriverTagsList(activeFilters, pageRequest);
            handleClose();
          });
        }
      } else {
        setStatus({ type: "error", message: validatedState });
      }
    }
  };

  const handleClearFilters = () => {
    props.getDriverTagsList({}).then((res) => {
      handleClose();
    });
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const tagBasedPermission = (type) => {
    if (initialState[type] === "OTHER") {
      return false;
    } else {
      return true;
    }
  };

  const isFilterApplicable = (value) => {
    if (modalState === "Filter" && filterFields) {
      return filterFields.includes(value) ? false : true;
    } else if (modalState === "Edit") {
      switch (value) {
        case "tag_type":
          return tagBasedPermission(value);
        default:
          return false;
      }
    } else {
      return false;
    }
  };

  const getRequiredButtonPerms = () => {
    if (modalState === "Edit") {
      return [allActions.UPDATE];
    } else if (modalState === "Add" && isBulkUpload) {
      return [allActions.BULK_UPLOAD_OTHER_TAG];
    } else if (modalState === "Add") {
      return [allActions.CREATE];
    }
    return [];
  };

  const getSampleUrl = () => {
    switch (initialState.tag_type) {
      case "INCENTIVE":
        return sample_incentive_tag_csv;
      case "OTHER":
        return sample_other_tag_csv;
      default:
        return sample_accounting_tag_csv;
    }
  };

  //disable options based on permissions
  const isOptionDisabled = (key) => {
    if (modalState === "Add" && isBulkUpload) {
      switch (key) {
        case "ACCOUNTING_STRATEGY":
        case "ACCOUNTING":
        case "INCENTIVE":
        case "MING_TAG":
          return !allMenuActions[allActions.BULK_UPLOAD_FUTURE_ACCOUNTING_TAG];
        case "OTHER":
          return !allMenuActions[allActions.BULK_UPLOAD_OTHER_TAG];
        default:
          return false;
      }
    }
    return false;
  };

  useEffect(() => {
    //reset callback_key and presign_url for bulk upload
    setCallback_key("");
    setPresign_url("");
    if (!isValNull(activeId)) {
      props.getDriverTag(activeId);
    }
    //reset the reducer state to show empty modal
    if (modalState === "Add" && Object.keys(activeDriverTag).length > 0) {
      props.resetState({ state: "activeDriverTag" });
    }
  }, [activeId, modalState]);

  useEffect(() => {
    //set the initial state of form in modal
    if (activeDriverTag && modalState === "Edit") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeDriverTag[key]
          ? activeDriverTag[key]
          : getInitialState(initialState, key);
      });
      setInitialState(values);
    }
    if (activeFilters && modalState === "Filter") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFilters[key] ? activeFilters[key] : "";
      });
      if (activeFilters["type"]) {
        values["tag_type"] = activeFilters["type"];
      }
      setInitialState(values);
    }
  }, [activeDriverTag, activeFilters]);

  return (
    <NoFooterModal
      header={true}
      heading={`${modalState} Tag`}
      handleClose={handleClose}
      id="DriverTagsFormModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          {modalState === "Filter" && (
            <Button
              data-testid="filterFeatureBtn"
              onClick={handleClearFilters}
              className="sushi-btn"
            >
              Clear
            </Button>
          )}
          <Permission requiredPerms={getRequiredButtonPerms()}>
            <Button
              data-testid="submitButton"
              className="sushi-btn"
              onClick={handleSubmit}
            >
              {modalState === "Filter" ? "Apply" : "Submit"}
            </Button>
          </Permission>
        </BottomSectionModal>
      }
    >
      <PaginatedReactDropdown
        options={driverTags}
        data-testid="tagType"
        value={initialState.tag_type}
        labelWidth="10%"
        disabled={isFilterApplicable("tag_type")}
        handleChange={handleChange}
        keyToChange="tag_type"
        isOptionDisabled={isOptionDisabled}
        placeholder="Tag Type"
        showCross={false}
        id="tagTypeDropdown"
      />
      {isBulkUpload ? (
        // file uplaod
        <React.Fragment>
          <FileUpload
            title={"File"}
            uploadUrl="/tag-mapping/bulk-upsert-tags"
            callback_key={callback_key}
            presign_url={presign_url}
            handleClose={handleClose}
            keyName="callback_key"
            activeFile={activeFile}
            setActiveFile={setActiveFile}
            maxSize={0.5}
            acceptTypes=".csv"
            maxNumberOfRows={50000}
          />
          <NotesSection data-testid="notesBar">
            <InformationBar
              sampleUrl={getSampleUrl()}
              instructions={instructions}
            />
          </NotesSection>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Input
            value={initialState.name}
            data-testid="tagName"
            id="sushi-input"
            disabled={isFilterApplicable("name")}
            onChange={(e) => handleChange("name", e)}
            label="Tag Name"
          />
          <ToggleSwitch
            id="sushi-switch"
            className="semibold"
            size={11}
            spacing={3}
            isActive={initialState.enabled}
            disabled={isFilterApplicable("enabled")}
            handleChange={handleChange}
            keyName="enabled"
            label="Enable"
          />
        </React.Fragment>
      )}
      {modalState === "Edit" && (
        <React.Fragment>
          <Input
            data-testid="tagCreatedAt"
            id="sushi-input"
            disabled
            value={getReadableDateTime(initialState.created_at)}
            label="Created At"
          />
          <Input
            value={getReadableDateTime(initialState.updated_at)}
            data-testid="updatedAt"
            id="sushi-input"
            disabled
            label="Updated At"
          />
        </React.Fragment>
      )}
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { DriverTags, MenuActions } = state;
  return {
    activeDriverTag: DriverTags.activeDriverTag,
    activeFilters: DriverTags.activeFilters,
    currentPageTags: DriverTags.currentPageTags,
    allMenuActions: MenuActions.allMenuActions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createDriverTag: bindActionCreators(
      DriverTagsActions.createDriverTag,
      dispatch
    ),
    getDriverTagsList: bindActionCreators(
      DriverTagsActions.getDriverTagsList,
      dispatch
    ),
    getDriverTag: bindActionCreators(DriverTagsActions.getDriverTag, dispatch),
    resetState: bindActionCreators(DriverTagsActions.resetState, dispatch),
    updateDriverTag: bindActionCreators(
      DriverTagsActions.updateDriverTag,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverTagsFormModal);
